import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../../../lib/axios";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import axios from "../../../../lib/axios";

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'FacName', label: 'Facilities', minWidth: 100 },
  { id: 'FacDesc', label: 'Description', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const FacilitiesMaster = () => {
  const [formData, setFormData] = useState({
    FacName: "",
    FacDesc: "",
    Remark: "",
  });

  // const permissions = useModulePermissions("Facilities Master");

  const [error, setError] = useState({
    facName: false,
    facDesc: false,
    remark: false,
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentFacId, setCurrentFacId] = useState(null);
  const [mode, setMode] = useState("view");
  const [lastInsertedFacId, setLastInsertedFacId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const facNameRef = useRef(null);
  const facDescRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.FacId) {
      setCurrentFacId(location.state.FacId);
      fetchFacilitiesMasterData(location.state.FacId);
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchFacilitiesMasterData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(
        `FacilitiesMst/RetriveFacilitiesMst`,
        {
          FacId: parseInt(id),
          Flag: flag,
        }
      );

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        const facData = response.data.Data[0];
        setFormData({
          FacName: facData.FacName,
          FacDesc: facData.FacDesc,
          Remark: facData.Remark,
        });
        setStatus(facData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentFacId(facData.FacId);
      } else if (
        response.data.Status === 1 &&
        response.data.responseStatusCode === 2
      ) {
        toast.info(response.data.Message);
      } else {
        toast.error("Failed to fetch FacilitiesMaster data");
      }
    } catch (error) {
      console.error("Error fetching FacilitiesMaster data:", error);
      toast.error("Error fetching FacilitiesMaster data. Please try again.");
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('FacilitiesMst/getAllFacilitiesMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentFacId && currentFacId > 1) {
      await fetchFacilitiesMasterData(currentFacId, "P");
    }
  };

  const handleNext = async () => {
    if (currentFacId) {
      await fetchFacilitiesMasterData(currentFacId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "facilitiesMaster") {
      setFormData((prevState) => ({
        ...prevState,
        state: "",
      }));
    }

    if (name === "facilitiesMaster" && value !== "") {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === facDescRef.current) {
        remarkRef.current.focus();
      } else {
        facDescRef.current.focus();
      }
    }
  };

  const handleSave = async () => {
    let hasError = false;

    if (!formData.FacName) {
      toast.error("Fac Name is required");
      setError((prev) => ({ ...prev, facName: true }));
      hasError = true;
    } else {
      setError((prev) => ({ ...prev, facName: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        FacName: formData.FacName,
        FacDesc: formData.FacDesc,
        Remark: formData.Remark,
        Status: Status,
      };

      let response;
      if (mode === "edit") {
        payload.FacId = currentFacId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(
          `FacilitiesMst/UpdateFacilitiesMst`,
          payload
        );
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(
          `FacilitiesMst/InsertFacilitiesMst`,
          payload
        );
      }

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        toast.success(response.data.Message);
        if (mode === "add") {
          setLastInsertedFacId(response.data.Data);
          await fetchFacilitiesMasterData(response.data.Data);
          setMode("view");
          setIsFormDisabled(true);
          setCurrentFacId(response.data.Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      console.error("Error saving/updating facilitiesMaster:", error);
      toast.error("Error saving/updating facilitiesMaster. Please try again.");
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentFacId, "MstFacilities", "FacId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      FacName: "",
      FacDesc: "",
      Remark: "",
    });
    setCurrentFacId(null);

    setTimeout(() => {
      facNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchFacilitiesMasterData(1, "L");
      await UnLock(currentFacId, "MstFacilities", "FacId");
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      toast.error("Error occurred while cancelling. Please try again.");
    }
  };

  const resetForm = () => {
    setFormData({
      FacName: "",
      FacDesc: "",
      Remark: "",
    });
    setCurrentFacId(null);
    setMode("view");
  };

  const handleExit = () => {
    navigate("/facilitiesMastertable");
  };

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentFacId, "MstFacilities", "FacId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchFacilitiesMasterData(currentFacId, "D");
        await fetchFacilitiesMasterData(currentFacId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: 'column', sm: 'row', md: 'row' } 
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={
                  mode !== "view" || !currentFacId || currentFacId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: "0px 10px" }}
                className="three-d-button-next"
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== "view" || !currentFacId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Facilities Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Facilities Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="FacName"
                  name="FacName"
                  label={
                    <span>
                      Fac Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.FacName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.facName}
                  helperText={error.facName && ""}
                  inputRef={facNameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="FacDesc"
                  name="FacDesc"
                  label="Fac Desc"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.FacDesc}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.facDesc}
                  helperText={error.facDesc && ""}
                  inputRef={facDescRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.remark}
                  helperText={error.remark && ""}
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1 }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Facilities Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FacilitiesMaster;
